import React from 'react';
import PropTypes from 'prop-types';

import {oeInterfaceManager} from '../../react-oe/oe-interface';
import OEInterfaceAdapter from '../../react-oe/oe-interface-adapter';
import {OEHideFlags} from '../../react-oe/oe-types';
import OEToolbox from '../../lib/tools/oe-toolbox';

export default class OECoreHideLayer extends React.PureComponent {

    constructor(props) {
        super(props);

        this.oe = oeInterfaceManager.getInterface(this.props.moduleId);

        this.hideFlags = this.getHideFlags();
        this.appliedHideFlags = 0;

        this.state = {};
    }

    componentWillReceiveProps(nextProps) {
        if(!OEToolbox.shallowEqual(nextProps.hideFlags, this.props.hideFlags, true))     {
            this.updateHideFlags(nextProps);
        }
    }

    getHideFlags(props) {
        props = props || this.props;
        let hideFlags = typeof(props.hideFlags) == 'number' ? props.hideFlags : OEHideFlags.fromArray(props.hideFlags);
        return hideFlags;
    }

    updateHideFlags(props)  {
        let hideFlags = this.getHideFlags(props);
        if(hideFlags != this.hideFlags) {
            this.hideFlags = hideFlags;
            this.apply();
        }
    }

    apply(hideFlags) {
        hideFlags = typeof(hideFlags) == 'number' ? hideFlags : this.hideFlags;
        if(hideFlags === this.appliedHideFlags) return;
        
        if(this.oe.isReady())   {
            if(this.appliedHideFlags)   this.oe.sharedInterface.getUIControllerMisc().setHidden(false, this.appliedHideFlags);
            if(hideFlags)   this.oe.sharedInterface.getUIControllerMisc().setHidden(true, hideFlags);
            this.appliedHideFlags = hideFlags;
        }
    }

    updateState(released)   {
        if(!this.oe.isReady() || released === true)   {
            this.apply(0);
            this.appliedHideFlags = 0;
            return;
        }

        this.apply();
    }

    render() {
        return (
            <React.Fragment>
                <OEInterfaceAdapter moduleId={this.props.moduleId} receiver={this}/>
            </React.Fragment>
        );
    }
}

OECoreHideLayer.defaultProps = {
    moduleId: '',
    hideFlags: OEHideFlags.none
};

OECoreHideLayer.propTypes = {
    moduleId: PropTypes.string,
    hideFlags: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.arrayOf(PropTypes.oneOf([
            OEHideFlags.none, OEHideFlags.scene, OEHideFlags.ui
        ]))
    ])
};